var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQusAnswered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2eb77d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18141 -6701)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20,12a8,8,0,1,0,8,8A8.01,8.01,0,0,0,20,12Zm3.978,6.292-4.605,4.368a.7.7,0,0,1-.454.173.589.589,0,0,1-.454-.195l-2.422-2.486a.642.642,0,0,1,.93-.886L18.941,21.3l4.151-3.935a.642.642,0,0,1,.886.93Z",
    transform: "translate(18129 6689)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQusAnswered);
export default __webpack_public_path__ + "static/media/QusAnswered.52ed82ff95dd87cf7463d6f0c17479bc.svg";
export { ForwardRef as ReactComponent };